module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4QsJDBEavLU/EgAAANNJREFUSMft1jFKxGAQhuEnMeQSFrGwsfUCCkIukv8Gip5mL6A3cINrrWshCOLaSNZLbJq12ATS2CWp/hcGZhiYF6b6OJDhDm/YYT9S7bDubmcGsucRJf/VClmGG1wURWGxWLg6PTYm9fevqqo0TXOJ66R743ld16PLepabrbIsYZ10f873P5+mJDk5gzZFbj7y1MxEYRRGYRRGYRRG4UHYzuhrU3z06Woqlptt376nuIcQwnAxGo9fjRBCPz70QXg1QxB+wtEwfd/idYKo/9LdzuAPE/GIQMK/DXQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/territorio_exencionalta_borde.png
// module id = jyLu
// module chunks = 0